import { LOGO_SRC, BRAND_NAME } from "../../config";
import BookCallButton from "./BookCallButton";

export default function Nav() {
  return (
    <header className="fixed inset-x-0 top-0 z-50 bg-sunny">
      <nav
        className="mx-auto flex max-w-[1440px] items-center justify-between px-5 py-4 md:px-12 lg:px-20"
        aria-label="Main navigation"
      >
        <div className="flex items-center gap-4">
          <a href="#top" data-testid="nav-logo-link" aria-label={`${BRAND_NAME} — back to top`} className="shrink-0">
            {/* LOGO — swap the file in /public or change LOGO_SRC in src/config.js */}
            <img
              src={LOGO_SRC}
              alt={`${BRAND_NAME} logo`}
              className="h-10 w-auto md:h-12"
              data-testid="nav-logo"
            />
          </a>
          <span
            data-testid="nav-tagline"
            className="hidden -rotate-1 font-display text-base font-medium italic text-navy/70 lg:block"
          >
            It&rsquo;s more than paper.
          </span>
        </div>

        <div className="flex items-center gap-4 md:gap-9">
          <div className="hidden items-center gap-9 md:flex">
            <a
              href="#about"
              data-testid="nav-about-link"
              className="text-base font-extrabold tracking-wide text-navy transition-colors duration-300 hover:text-grape md:text-lg"
            >
              Our WHY
            </a>
          </div>
          <BookCallButton testId="nav-book-call-btn">Book a call with the founder</BookCallButton>
        </div>
      </nav>
    </header>
  );
}
